import './polyfills';
import model from '@/ts/model';
import globalFunctions from './ts/global-functions';
import { showNotification } from './ts/management/notifications-management';
import { initManagementModulesAndModelRefs } from './ts/management/management-registry';

window.EGOE ||= {};
Object.assign(window.EGOE, globalFunctions);

initManagementModulesAndModelRefs();

(window as any).modelTest = model;
(window as any).showNotification = showNotification;